import userApi from '@/api/users'
import orderApi from '@/api/orders'
import parentsApi from '@/api/parents'

export default {
  state: {
    parentDetails: {},
    parentOrders: [],
    parentSubjects: [],
  },

  mutations: {
    setParentDetails(state, parentDetails) {
      state.parentDetails = parentDetails
    },
    setParentOrders(state, orders) {
      state.parentOrders = orders
    },
    setSubjects(state, subjects = []) {
      state.parentSubjects = subjects
    }
  },

  actions: {
    async getParent({ commit }, parentId) {
      try {
        const { data } = await userApi.getParent({
          filter: {
            id: parentId
          }
        })

        if (data?.success) {
          const subjectsData = await parentsApi.getSubjects(parentId)
          const subjects = subjectsData?.data?.body?.subjects || []

          commit('setParentDetails', data.result.rows[0])
          commit('setSubjects', subjects)
          return data.result.rows[0]
        }
      } catch (error) {
        console.warn(error)
      }
    },

    async getParentOrders({ commit }, filter) {
      try {
        const { data } = await orderApi.getOrders(filter)

        if (data?.success) {
          commit('setParentOrders', data.result)
        }
      } catch (error) {
        console.warn(error)
      }
    }
  },

  getters: {
    parentDetails: ({ parentDetails }) => parentDetails,
    parentOrders: ({ parentOrders }) => parentOrders,
    parentSubjects: ({ parentSubjects }) => parentSubjects,
  }
}
